import { lazy, Suspense } from "react";
import { HOTELS, TRAVEL_INFO } from "../data/content";

// Leaflet stays out of the main guest bundle until the map is rendered.
const VenueMap = lazy(() => import("./VenueMap"));

export function Travel() {
  return (
    <section id="travel" className="section">
      <div className="container container--1080">
        <div className="section-head">
          <p className="eyebrow">Travel &amp; Stay</p>
          <h2 className="h2">Getting to Leesburg</h2>
        </div>

        <div className="grid grid--gap24 auto-280 travel__cards">
          {HOTELS.map((hotel) => (
            <article className="card travel__card" key={hotel.name}>
              <h3 className="h3">{hotel.name}</h3>
              <p className="card-time">{hotel.distance}</p>
              <p className="body travel__detail">{hotel.detail}</p>
              <p className="fine" style={{ color: "var(--muted)" }}>{hotel.rate}</p>
              <p className="fine" style={{ color: "var(--muted)" }}>Booking code: {hotel.code}</p>
              <a className="btn btn--outline" href={hotel.url} target="_blank" rel="noreferrer">
                Reserve a room
                <span className="visually-hidden"> at {hotel.name}</span>
              </a>
            </article>
          ))}
        </div>

        <div className="grid grid--gap40 auto-260 travel__info">
          {TRAVEL_INFO.map((item) => (
            <div key={item.title}>
              <h3 className="h3">{item.title}</h3>
              <p className="body">{item.body}</p>
            </div>
          ))}
        </div>

        <Suspense fallback={<div className="placeholder travel__map" />}>
          <VenueMap />
        </Suspense>
      </div>
    </section>
  );
}
